export default __webpack_public_path__ + "static/media/werewolves-win.29e324d3.mp3";